export const AUTHENTICATION_FAILURE_TOPIC = "AUTHENTICATION_FAILURE_TOPIC";
